import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { ConfirmPasswordValidator } from '../../../_common/_helper/confirm-password.validator';
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  public forgetPasswordForm: FormGroup;
  submitted = false;
  change: boolean = false;
  loadingspinner: boolean = false;
  constructor(
    private authService: AuthService,   
    public dialog: MatDialog,
    private fb: FormBuilder,
    private toastr: ToastrService, 
   
    public dialogRef: MatDialogRef<ForgetPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
   
    this.forgetPasswordForm = this.fb.group({
      emailId: [null, [Validators.required, Validators.email]],
      verifyCode: [null, [Validators.required]],
      newPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
      confirmPassword: [null, [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,20}')]],
    }, {
        validator: ConfirmPasswordValidator('newPassword', 'confirmPassword')
    })
  }

  ngOnInit() {
 
  }

  get f() { return this.forgetPasswordForm.controls; }
  
  sendCode() {
    
    this.submitted = true;  
    if (!this.f.emailId.value) {
      this.toastr.error("Enter Email Id", 'Error');
    }    
    else
    {
      this.loadingspinner = true;
      var post = {       
        emailId: this.f.emailId.value      
      };

      this.authService.forgetPasswordVerifyCode(post).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; }) => {
        debugger;
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          this.change = true;
    
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }

  forgetPassword(post: any) {
    
    this.submitted = true;

    if (this.forgetPasswordForm.valid) {
      this.loadingspinner = true;
      this.authService.forgetPassword(post).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; }) => {
        this.loadingspinner = false;
        if (response.apiStatus == true) {
          this.toastr.success(response.apiMessage, 'Success');
          this.dialogRef.close();
        } else {
          this.toastr.error(response.apiMessage, 'Error');
        }

      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }

}
